function parseGptResponse(text, matches) {
  const blocks = {};
  blocks.raw = text;

  const makeRegex = (prefixStr) => {
    // Create a dynamic regular expression for the prefix
    return new RegExp("```" + prefixStr + "\\n([\\s\\S]*?)```", "g");
  };

  matches.forEach(match => {
    const { key, parse } = match;
    const regex = makeRegex(key);
    const matchedResult = regex.exec(text); // Use exec() to capture groups

    if (matchedResult) {
      const result = matchedResult[1]; // Group 1 will contain the code block

      try {
        blocks[key] = parse ? JSON.parse(result) : result; // Parse or store the result
      } catch (e) {
        console.error(`Failed to parse block for key ${key}:`, e);
      }
    }
  });

  return blocks;
}

export {
  parseGptResponse
};
